import React from 'react';

export interface FileManagerOptionsContext {
  defaultFileUploadExtensions?: Readonly<string[]>;
}

const FileManagerOptionsContext = React.createContext<FileManagerOptionsContext | undefined>(
  undefined,
);

type Props = {
  children: React.ReactNode;
  defaultFileUploadExtensions?: Readonly<string[]>;
};

const FileManagerOptionsState = (props: Props) => {
  return (
    <FileManagerOptionsContext.Provider
      value={{
        defaultFileUploadExtensions: props.defaultFileUploadExtensions,
      }}
    >
      {props.children}
    </FileManagerOptionsContext.Provider>
  );
};

export { FileManagerOptionsContext, FileManagerOptionsState };
